import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Train"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M15.75 1.5H8.25C6.17893 1.5 4.5 3.17893 4.5 5.25V15C4.5071 16.8801 5.90534 18.4644 7.77 18.705L6.75 22.5H8.3025L9.3075 18.75H14.6925L15.6975 22.5H17.25L16.23 18.705C18.0947 18.4644 19.4929 16.8801 19.5 15V5.25C19.5 3.17893 17.8211 1.5 15.75 1.5ZM18 6V11.25H6V6H18ZM8.25008 3H15.7501C16.7013 3.00267 17.548 3.6032 17.8651 4.5H6.13508C6.45214 3.6032 7.29889 3.00267 8.25008 3ZM15.75 17.25H8.25C7.29881 17.2473 6.45206 16.6468 6.135 15.75H8.25V14.25H6V12.75H18V14.25H15.75V15.75H17.865C17.5479 16.6468 16.7012 17.2473 15.75 17.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Train.vue"]]);
